export default __webpack_public_path__ + "static/media/secondary_illustration.2ab53fa1.png";